import { render, staticRenderFns } from "./ButtonUploader.vue?vue&type=template&id=3b0b0def&scoped=true&"
import script from "./ButtonUploader.vue?vue&type=script&lang=js&"
export * from "./ButtonUploader.vue?vue&type=script&lang=js&"
import style0 from "./ButtonUploader.vue?vue&type=style&index=0&id=3b0b0def&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b0def",
  null
  
)

export default component.exports